<template>
  <div>
  <Movementmenu_govem/>
    <v-container id="home_menu" fluid tag="section">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title
            >ประมวลผลข้อมูลการย้าย 3 สับเปลี่ยนตำแหน่ง</v-toolbar-title
          >
        </v-toolbar>

        <v-simple-table>
          <tbody>
            <tr>
              <td class="text-center" width="33%">
                <v-btn
                  elevation="2"
                  rounded
                  color="primary"
                  dark
                  @click="Switch_personnelAll()"
                >
                  <v-icon left>mdi-clipboard-check</v-icon> ดึงข้อมูลประมวลผล
                </v-btn>
              </td>
              <td class="text-center" width="33%">
                <v-btn 
                  elevation="2" 
                  rounded 
                  color="success" 
                  @click="exportExcel()"
                >
                  <v-icon left>mdi-file-excel</v-icon> ส่งออกข้อมูล (XLSX)
                </v-btn>
              </td>
              <td class="text-right" width="33%">
                <h2 class="mr-4 primary--text">ประมวลผล 3 สับเปลี่ยน</h2>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-card flat class="mt-2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
            single-line
            hide-details
            dense
            filled
            class="mb-4"
          />
          <v-data-table
            v-model="select_item"
            color="success"
            :loading="loading"
            :headers="headers"
            :items="conditions_transfers"
            :search="search"
            :items-per-page="20"
            class="elevation-1"
          >
            <template v-slot:item.select_item="{ item }">
              <v-checkbox v-model="search" :value="item.id_card_a"></v-checkbox>
            </template>

            <!-- ปรับเปลี่ยนการแสดงผลให้อ่านง่ายและชัดเจนขึ้นสำหรับการอนุมัติ -->
            <template v-slot:item.title_s_a="{ item }">
              <div class="font-weight-bold">
                {{ item.title_s_a }}{{ item.frist_name_a }} {{ item.last_name_a }}
              </div>
              <small class="grey--text">{{ item.id_card_a }}</small>
            </template>

            <template v-slot:item.title_s_b="{ item }">
              <div class="font-weight-bold">
                {{ item.title_s_b }}{{ item.frist_name_b }} {{ item.last_name_b }}
              </div>
              <small class="grey--text">{{ item.switch_position }}</small>
            </template>

            <template v-slot:item.college_name_a="{ item }">
              <v-chip color="warning" outlined dark>
                <span style="font-size:14px;"> {{ item.college_name_a }}</span>
              </v-chip>
            </template>

            <template v-slot:item.college_name_b="{ item }">
              <v-chip color="info" outlined dark>
                <span style="font-size:14px;"> {{ item.college_name_b }}</span>
              </v-chip>
            </template>

            <template v-slot:item.status_process="{ item }">
              <div class="text-center">
                <v-tooltip top v-if="item.id_card_a !== item.switch_position">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon large color="success" v-bind="attrs" v-on="on">
                      mdi-check-circle
                    </v-icon>
                  </template>
                  <span>พร้อมสับเปลี่ยนคู่สำเร็จ</span>
                </v-tooltip>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon large color="warning" v-bind="attrs" v-on="on">
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>รอการจับคู่ / จับคู่ไม่สมบูรณ์</span>
                </v-tooltip>
              </div>
            </template>
            
            <template v-slot:item.actions="{ item }">
              <div class="text-center">
                <v-chip
                  v-if="item.status_select_a === 'demand' || item.status_select_b === 'demand'"
                  color="primary"
                  dark
                  small
                >
                  <span style="font-size:14px;">รับย้ายแล้ว</span>
                </v-chip>

                <v-chip
                  v-else-if="item.status_select_a === 'agree' || item.status_select_b === 'agree'"
                  color="success"
                  dark
                  small
                >
                  <span style="font-size:14px;">ปกติ</span>
                </v-chip>

                <v-btn
                  v-else-if="item.college_code_susss >= 1"
                  color="error"
                  icon
                  @click.stop="deletePosition(item.id_ref)"
                >
                  <v-icon large>mdi-delete-circle</v-icon>
                </v-btn>
                
                <v-btn
                  v-else
                  color="info"
                  rounded
                  small
                  @click.stop="select_idPosition(item.id_ref)"
                >
                  <v-icon left>mdi-credit-card-plus</v-icon> อนุมัติสับเปลี่ยน
                </v-btn>
              </div>
            </template>

            <template v-slot:item.college_code_susss="{ item }">
              <v-chip :color="getColor(item.college_code_susss)" dark small v-if="item.college_code_susss">
                <span>{{ item.college_code_susss }}</span>
              </v-chip>
            </template>

            <template v-slot:item.id_postion_susss="{ item }">
              <v-chip :color="getColor(item.id_postion_susss)" dark small v-if="item.id_postion_susss">
                <span>{{ item.id_postion_susss }}</span>
              </v-chip>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
              >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
            >
          </v-data-table>
        </v-card>
      </v-card>

      <!-- V-model canceldialog -->
      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="error"
              icon="mdi-clipboard-text"
              title="ยกเลิกรายการสับเปลี่ยน"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                <v-container grid-list-md>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-4" outlined>
                        <h3 class="primary--text">ผู้ขอย้าย A</h3>
                        <v-divider class="mb-3"></v-divider>
                        <p><b>รหัสอ้างอิง:</b> {{ transference_personnels.tid_ref }}</p>
                        <p><b>รหัสบัตรประชาชน:</b> {{ transference_personnels.id_card }}</p>
                        <p>
                          <b>ชื่อ-นามสกุล:</b> 
                          {{ transference_personnels.title_s }}{{ transference_personnels.frist_name }} {{ transference_personnels.last_name }}
                        </p>
                        <p>
                          <b>สถานศึกษาปัจจุบัน:</b> {{ transference_personnels.college_name }} 
                          <v-chip x-small>{{ transference_personnels.college_code }}</v-chip>
                        </p>
                        <p><b>เลขที่ตำแหน่งปัจจุบัน:</b> {{ transference_personnels.id_position }}</p>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-4" outlined>
                        <h3 class="info--text">ผู้สับเปลี่ยน B</h3>
                        <v-divider class="mb-3"></v-divider>
                        <p><b>รหัสอ้างอิง:</b> {{ transference_personnels_b.tid_ref }}</p>
                        <p><b>รหัสบัตรประชาชน:</b> {{ personnel_temporarys.id_card }}</p>
                        <p>
                          <b>ชื่อ-นามสกุล:</b> 
                          {{ personnel_temporarys.title_s }}{{ personnel_temporarys.frist_name }} {{ personnel_temporarys.last_name }}
                        </p>
                        <p>
                          <b>สถานศึกษาปัจจุบัน:</b> {{ personnel_temporarys.college_name }} 
                          <v-chip x-small>{{ personnel_temporarys.college_code }}</v-chip>
                        </p>
                        <p><b>เลขที่ตำแหน่งปัจจุบัน:</b> {{ personnel_temporarys.id_position }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="canceldialog = false" text rounded>
                <v-icon left>mdi-close</v-icon>ปิดหน้าต่าง
              </v-btn>
              <v-btn large color="error" @click.stop="cancelSubmit()" rounded>
                <v-icon left>mdi-check-circle</v-icon>ยืนยันยกเลิกรายการนี้
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model positiondialog -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-account-switch"
              title="ตรวจสอบและอนุมัติการสลับตำแหน่ง"
              class="px-5 py-3 text_google"
            >
              <small>รอบที่ประมวลผล: {{ transference_personnels.time_ss }}/{{ transference_personnels.year_ss }}</small>
            </base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container grid-list-md>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-4" outlined>
                        <h3 class="primary--text mb-2"><v-icon>mdi-account</v-icon> ผู้ขอย้าย (A)</h3>
                        <v-divider class="mb-4"></v-divider>
                        <p><b>รหัสอ้างอิง:</b> <v-chip small color="primary" dark>{{ transference_personnels.tid_ref }}</v-chip></p>
                        <p><b>เลขบัตรประชาชน:</b> {{ transference_personnels.id_card }}</p>
                        <p>
                          <b>ชื่อ-นามสกุล:</b> 
                          {{ transference_personnels.title_s }}{{ transference_personnels.frist_name }} {{ transference_personnels.last_name }}
                        </p>
                        <p>
                          <b>สถานศึกษา:</b> {{ transference_personnels.college_name }} 
                          <span class="grey--text">[{{ transference_personnels.college_code }}]</span>
                        </p>
                        <p><b>เลขที่ตำแหน่ง:</b> {{ transference_personnels.id_position }}</p>
                        
                        <v-select
                          class="mt-4"
                          v-model="transference_personnels.id_branch"
                          :items="personnel_educations"
                          item-text="name_branch"
                          item-value="id_branch"
                          label="เลือกสาขาวิชา (A)"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'กรุณาเลือกสาขาวิชา']"
                        ></v-select>
                      </v-card>
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-4" outlined>
                        <h3 class="info--text mb-2"><v-icon>mdi-account-sync</v-icon> ผู้สลับตำแหน่ง (B)</h3>
                        <v-divider class="mb-4"></v-divider>
                        <p><b>รหัสอ้างอิง:</b> <v-chip small color="info" dark>{{ transference_personnels_b.tid_ref }}</v-chip></p>
                        <p><b>เลขบัตรประชาชน:</b> {{ personnel_temporarys.id_card }}</p>
                        <p>
                          <b>ชื่อ-นามสกุล:</b> 
                          {{ personnel_temporarys.title_s }}{{ personnel_temporarys.frist_name }} {{ personnel_temporarys.last_name }}
                        </p>
                        <p>
                          <b>สถานศึกษา:</b> {{ personnel_temporarys.college_name }} 
                          <span class="grey--text">[{{ personnel_temporarys.college_code }}]</span>
                        </p>
                        <p><b>เลขที่ตำแหน่ง:</b> {{ personnel_temporarys.id_position }}</p>
                        
                        <v-select
                          class="mt-4"
                          v-model="personnel_educations_b.id_branch"
                          :items="personnel_educations_b"
                          item-text="name_branch"
                          item-value="id_branch"
                          label="เลือกสาขาวิชา (B)"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'กรุณาเลือกสาขาวิชา']"
                        ></v-select>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" text rounded>
                <v-icon left>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="updatepositionSubmit()"
                rounded
                elevation="2"
              >
                <v-icon left>mdi-content-save</v-icon>บันทึกการอนุมัติสับเปลี่ยน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
    
    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large left dark>{{ snackbar.icon }}</v-icon>
        <span style="font-size: 16px;">{{ snackbar.text }}</span>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu_govem from '../../../components/admin/movementmenu_govem.vue';

export default {
  name: "HrvecProcessTransfer",
  data() {
    return {
      select_item: [],
      singleSelect: true,
      selected: [],
      value: "4",
      loading: false,
      ApiKey: "HRvec2021",
      process_transfer: {},
      valid: true,
      times_s: "",
      year_s: "",
      row: null,
      man_powers: [],
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      headers: [
        { text: "ผู้ขอย้าย (A)", align: "left", value: "title_s_a" },
        { text: "วิทยาลัย (A)", align: "left", value: "college_name_a" },
        { text: "สถานะจับคู่", align: "center", value: "status_process" },
        { text: "ผู้สับเปลี่ยน (B)", align: "left", value: "title_s_b" },
        { text: "วิทยาลัย (B)", align: "left", value: "college_name_b" },
        { text: "รหัสวิทยาลัยใหม่", align: "center", value: "college_code_susss" },
        { text: "เลขตำแหน่งใหม่", align: "center", value: "id_postion_susss" },
        {
          text: "การดำเนินการ",
          align: "center",
          value: "actions",
          sortable: false
        }
      ],
      search: "",
      pagination: {},
      rowsperpage: [
        25,
        50,
        100,
        { text: "All", value: -1 }
      ],
      conditions_transfers: [],
      period_match: [],
      delete_transference: [],
      conditions_branchs: [],
      transference_locations: [],
      transference_personnels: [],
      edittransference_location: [],
      positiondialog: false,
      deletetransference_locationdialog: false,
      canceldialog: false,
      conditons_transfer_successs: [],
      conditons_transfer_successs_b: [],
      transference_personnels_id_ref: [],
      man_powerss: [],
      updatepositions: {},
      updatepositions_b: {},
      updatepositions_condition: {},
      personnel_educations: [],
      personnel_temporarys: [],
      transference_personnels_b: [],
      personnel_educations_b: []
    };
  },
  async mounted() {
    await this.period_QueryAll();
    await this.man_powerQuery();
    await this.Switch_personnelAll();
  },
  methods: {
    // ฟังก์ชันเพิ่มเติมสำหรับการ Export เป็น XLSX
    async exportExcel() {
      try {
        if (!this.conditions_transfers || this.conditions_transfers.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "ไม่มีข้อมูล",
            text: "ไม่พบข้อมูลสับเปลี่ยนตำแหน่งสำหรับการส่งออก",
            showConfirmButton: false,
            timer: 1500
          });
          return;
        }

        // จัดเตรียมชุดข้อมูล (Mapping ข้อมูลดิบให้อ่านง่าย)
        const dataToExport = this.conditions_transfers.map((item, index) => {
          return {
            "ลำดับ": index + 1,
            "รหัสบัตรประชาชน (A)": item.id_card_a || "-",
            "ชื่อ-นามสกุล (A)": `${item.title_s_a || ''}${item.frist_name_a || ''} ${item.last_name_a || ''}`.trim(),
            "วิทยาลัยปัจจุบัน (A)": item.college_name_a || "-",
            "รหัสบัตรประชาชนคู่สับเปลี่ยน (B)": item.switch_position || "-",
            "ชื่อ-นามสกุลคู่สับเปลี่ยน (B)": `${item.title_s_b || ''}${item.frist_name_b || ''} ${item.last_name_b || ''}`.trim(),
            "วิทยาลัย (B)": item.college_name_b || "-",
            "สถานะการจับคู่": item.id_card_a !== item.switch_position ? 'พร้อมสับเปลี่ยนคู่สำเร็จ' : 'จับคู่ไม่สมบูรณ์',
            "สถานะการดำเนินการ": item.status_select_a === 'demand' || item.status_select_b === 'demand' ? 'รับย้าย' : (item.status_select_a === 'agree' || item.status_select_b === 'agree' ? 'ปกติ' : 'รอดำเนินการ'),
            "รหัสวิทยาลัยที่ย้ายไป": item.college_code_susss || "-",
            "เลขที่ตำแหน่งใหม่": item.id_postion_susss || "-"
          };
        });

        // ใช้ Dynamic Import เรียก xlsx เพื่อลดปัญหาโหลดสคริปต์หน้าเว็บ
        const XLSX = await import("xlsx");
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ข้อมูลประมวลผลสับเปลี่ยน");
        
        // บันทึกไฟล์
        XLSX.writeFile(workbook, `สรุปข้อมูลสับเปลี่ยนตำแหน่ง_${this.time_stamp}.xlsx`);
        
        Swal.fire({
          icon: "success",
          title: "ส่งออกไฟล์ Excel สำเร็จ",
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error("Export Excel Error: ", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการส่งออก",
          text: "โปรดตรวจสอบว่าได้ติดตั้ง package: npm install xlsx",
          showConfirmButton: true
        });
      }
    },
    // สิ้นสุดฟังก์ชันใหม่ ---------------------------

    async man_powerQuery(college_code) {
      let man_power_result;
      man_power_result = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        college_code: college_code
      });
      this.man_powers = man_power_result.data;
    },
    async Switch_personnelAll() {
      this.loading = true;
      let result = await this.$http
        .post("process_transfer_govem.php", {
          ApiKey: this.ApiKey,
          switchs_normal: "Ok",
          time_s: this.period_match.period_times,
          year_s: this.period_match.period_year
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = result.data;
    },

    async period_QueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_id: "401"
        })
        .finally(() => (this.loading = false));
      this.period_match = result.data;
    },
    async select_idPosition(id_ref) {
      let result_tran = await this.$http
        .post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        })
        .finally(() => (this.loading = false));
      this.transference_personnels = result_tran.data;
      let result_personnel = await this.$http
        .post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        })
        .finally(() => (this.loading = false));
      this.personnel_temporarys = result_personnel.data;
      let result_education = await this.$http
        .post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_educations = result_education.data;
      let result_education_b = await this.$http
        .post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        })
        .finally(() => (this.loading = false));
      this.personnel_educations_b = result_education_b.data;
      let result_tran_b = await this.$http
        .post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position,
          time_s: this.transference_personnels.time_ss,
          year_s: this.transference_personnels.year_ss
        })
        .finally(() => (this.loading = false));
      this.transference_personnels_b = result_tran_b.data;
      this.positiondialog = true;
      // this.man_powerQuery(); // Not strictly needed without args here unless using form data
    },
    async transference_locationDelete() {
      this.deletetransference_locationdialog = true;
    },
    async deletetransference_locationSubmit() {
      if (this.$refs.edituserform.validate()) {
        let result = await this.$http.post(
          "transference_location.delete.admin.php"
        );
        if (result.data.status == true) {
          this.conditions_transfers = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.Switch_personnelAll(); // Adjusted from conditions_transferQueryAll() which doesn't exist
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการลบผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.deletetransference_locationdialog = false;
      }
    },
    async deletePosition(id_ref) {
      let result_con = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels = result_con.data;
      let result_personnel = await this.$http
        .post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        })
        .finally(() => (this.loading = false));
      this.personnel_temporarys = result_personnel.data;
      let result_tran_b = await this.$http
        .post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position,
          time_s: this.transference_personnels.time_ss,
          year_s: this.transference_personnels.year_ss
        })
        .finally(() => (this.loading = false));
      this.transference_personnels_b = result_tran_b.data;
      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });
      this.conditons_transfer_successs = result_cts.data;
      let result_cts_b = await this.$http.post(
        "conditons_transfer_success.php",
        {
          ApiKey: this.ApiKey,
          ctsid_card: this.transference_personnels.switch_position,
          ctstime_s: this.transference_personnels.time_ss,
          ctsyear_s: this.transference_personnels.year_ss
        }
      );
      this.conditons_transfer_successs_b = result_cts_b.data;
      this.canceldialog = true;
    },
    async cancelSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.conditons_transfer_successs.ApiKey = this.ApiKey;
        this.conditons_transfer_successs_b.ApiKey = this.ApiKey;
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs
        );
        let result_cts_b = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs_b
        );
        if (
          result_cts.data.status == true &&
          result_cts_b.data.status == true
        ) {
          this.snackbar.icon = "mdi-check-circle";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.Switch_personnelAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "error";
          this.snackbar.text = "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
        this.canceldialog = false;
      }
    },
    /// updatepositionSubmit
    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        this.updatepositions.ApiKey = this.ApiKey;
        this.updatepositions.ctstime_s = this.transference_personnels.time_ss;
        this.updatepositions.ctsyear_s = this.transference_personnels.year_ss;
        this.updatepositions.ctsid_postion_old = this.transference_personnels.id_position;
        this.updatepositions.ctscollege_code_old = this.transference_personnels.college_code;
        this.updatepositions.ctsid_card = this.transference_personnels.id_card;
        this.updatepositions.ctsid_ref = this.transference_personnels.tid_ref;
        this.updatepositions.ctsname_position = "ครู";
        this.updatepositions.ctscollege_code = this.personnel_temporarys.college_code;
        this.updatepositions.ctsid_position = this.personnel_temporarys.id_position;
        this.updatepositions.ctsid_branch = this.transference_personnels.id_branch;
        this.updatepositions.ctsstatus_select = "sw_normal";

        this.updatepositions_b.ApiKey = this.ApiKey;
        this.updatepositions_b.ctstime_s = this.transference_personnels_b.time_ss;
        this.updatepositions_b.ctsyear_s = this.transference_personnels_b.year_ss;
        this.updatepositions_b.ctsid_postion_old = this.personnel_temporarys.id_position;
        this.updatepositions_b.ctscollege_code_old = this.personnel_temporarys.college_code;
        this.updatepositions_b.ctsid_card = this.personnel_temporarys.id_card;
        this.updatepositions_b.ctsid_ref = this.transference_personnels_b.tid_ref;
        this.updatepositions_b.ctsname_position = "ครู";
        this.updatepositions_b.ctscollege_code = this.transference_personnels.college_code;
        this.updatepositions_b.ctsid_position = this.transference_personnels.id_position;
        this.updatepositions_b.ctsid_branch = this.personnel_educations_b.id_branch;
        this.updatepositions_b.ctsstatus_select = "sw_normal";

        let result_a = await this.$http.post(
          "conditons_transfer_success.insert.php",
          this.updatepositions
        );
        let result_b = await this.$http.post(
          "conditons_transfer_success.insert.php",
          this.updatepositions_b
        );
        if (result_a.data.status == true && result_b.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกการสับเปลี่ยนเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.Switch_personnelAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.positiondialog = false;
      }
    },
    getColor(calories) {
      if (calories > 0) return "success";
      else return "";
    }
  },
  computed: {
    time_stamp() {
      return Date.now();
    },
    period_match_call() {
      let period_year = this.period_match.period_year;
      let period_times = this.period_match.period_times;
      return period_times + "/" + period_year;
    },
    color() {
      return "brown darken-4";
    }
  },
  components: { Movementmenu_govem }
};
</script>

<style lang="scss" scoped>
.font-weight-bold {
  font-weight: 600;
}
</style>